import React from 'react';
import { usePortfolio, STEPS } from '../context/PortfolioContext';
import './Stepper.css';

const Stepper = () => {
  const { currentStep, canAccessStep, goToStep, completedSteps } = usePortfolio();

  const handleStepClick = (stepNumber) => {
    if (canAccessStep(stepNumber) || completedSteps.includes(stepNumber)) {
      goToStep(stepNumber);
    }
  };

  return (
    <div className="stepper">
      <div className="stepper-container">
        {STEPS.map((step, index) => {
          const isActive = currentStep === step.number;
          const isCompleted = completedSteps.includes(step.number) || currentStep > step.number;
          const isAccessible = canAccessStep(step.number) || isCompleted;

          return (
            <React.Fragment key={step.number}>
              <div
                className={`stepper-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isAccessible ? 'accessible' : 'disabled'}`}
                onClick={() => isAccessible && handleStepClick(step.number)}
                role="button"
                tabIndex={isAccessible ? 0 : -1}
                onKeyPress={(e) => e.key === 'Enter' && isAccessible && handleStepClick(step.number)}
              >
                <div className="step-circle">
                  {isCompleted && !isActive ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  ) : (
                    <span>{step.number}</span>
                  )}
                </div>
                <span className="step-label">{step.label}</span>
              </div>
              {index < STEPS.length - 1 && (
                <div className={`stepper-connector ${currentStep > step.number ? 'completed' : ''}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
